import { baseRoute } from '../../constants/routes';

export const PERMISSION_ROUTE = baseRoute + '/permission-management';

export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';

export const CREATE_PERMISSION = 'CREATE_PERMISSION';
export const CREATE_PERMISSION_SUCCESS = 'CREATE_PERMISSION_SUCCESS';

export const UPDATE_PERMISSION = 'UPDATE_PERMISSION';
export const UPDATE_PERMISSION_SUCCESS = 'UPDATE_PERMISSION_SUCCESS';

export const INVITE_PERMISSION = 'INVITE_PERMISSION';
export const INVITE_PERMISSION_SUCCESS = 'INVITE_PERMISSION_SUCCESS';
